import { Command } from 'commander'
import { registerChatCommand } from './chat'
import { registerRunCommand } from './run'
import { registerInitCommand } from './init'
import { registerDoctorCommand } from './doctor'
import { registerDevCommand } from './dev'
import { registerConfigCommand } from './config'
import { registerTunnelCommand } from './tunnel'
import { registerRagCommand } from './rag'
import { registerAiCommand } from './ai'
import { registerFlowCommand } from './flow'
import { registerPiiCommand } from './pii'
import { registerRulesCommand } from './rules'
import { registerAddCommand } from './add'
import { registerDiffCommand, registerUpdateCommand } from './registry-maintenance'

export function createCli(): Command {
  const program = new Command()
  program
    .name('agentskit')
    .description('AgentsKit CLI for chat demos and project bootstrapping.')

  registerChatCommand(program)
  registerRunCommand(program)
  registerInitCommand(program)
  registerDoctorCommand(program)
  registerDevCommand(program)
  registerConfigCommand(program)
  registerTunnelCommand(program)
  registerRagCommand(program)
  registerAiCommand(program)
  registerFlowCommand(program)
  registerPiiCommand(program)
  registerRulesCommand(program)
  registerAddCommand(program)
  registerDiffCommand(program)
  registerUpdateCommand(program)

  return program
}
